import { render, staticRenderFns } from "./TieBreakerRules.vue?vue&type=template&id=79749c20&"
import script from "./TieBreakerRules.vue?vue&type=script&lang=js&"
export * from "./TieBreakerRules.vue?vue&type=script&lang=js&"
import style0 from "./TieBreakerRules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports